/**
 * @file     transientNetworkError.ts
 * @purpose  Detect benign transient network/stream-abort errors (mostly iOS
 *           Safari closing in-flight RSC streams when the tab backgrounds or
 *           the user navigates away). These surface in the app error boundary
 *           with no stack and no digest — they must not trigger crash reports
 *           or the "Something went wrong" UI.
 */

const TRANSIENT_NETWORK_PATTERNS = [
  'Connection closed',
  'Load failed',
  'The network connection was lost',
  'BodyStreamBuffer was aborted',
  'Network connection lost',
  'cancelled',
  'The operation was aborted',
];

const TRANSIENT_NETWORK_NAMES = ['AbortError'];

export function isTransientNetworkError(
  error: { name?: string; message?: string } | null | undefined,
): boolean {
  if (!error) return false;
  if (error.name && TRANSIENT_NETWORK_NAMES.includes(error.name)) return true;
  const msg = error.message ?? '';
  return TRANSIENT_NETWORK_PATTERNS.some((p) => msg.includes(p));
}
